import { render, staticRenderFns } from "./ClaimsRIBordereaux.vue?vue&type=template&id=27ed13dc&"
import script from "./ClaimsRIBordereaux.vue?vue&type=script&lang=js&"
export * from "./ClaimsRIBordereaux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports